<template>
  <!-- 沟通记录展示聊天列表用 -->
  <div class="message-scroll-wrap">
    <div v-for="item in currentMessageList" :id="'item' + item.ID" :key="item.ID" class="list-wrap">
      <!-- 系统时间 showTime 前端自定义字段-->
      <im-system v-if="item.showTime" :message="item" />
      <!-- 消息体 hideMessage 前端自定义字段 im-system 用于显示：您撤回了一条消息，您删除了一条消息-->
      <div v-if="item.from === '@TIM#SYSTEM'" />
      <im-message
        v-else-if="!item.isRevoked && !item.isDeleted && !isCustomTxt(item.payload)"
        :message="item"
        :message-list="currentMessageList"
        @play="onPlay"
      />
      <im-revoke v-else :message="item" />
    </div>
    <div v-if="currentMessageList.length" class="no-message">没有更多啦</div>
    <audio
      :src="audioUrl"
      @canplay="onCanplay"
      @ended="stopAudio"
      @error="onError"
      ref="audioRef"
    ></audio>
  </div>
</template>

<script>
import { getMessageListRecord } from '@/timpackage/config/config'
import { formatImMessage } from '@/timpackage/utils/formatImMessage'
export default {
  props: {
    hospitalID: {
      // 上级医院id
      type: String,
      default: ''
    },
    visitID: {
      // 会话id
      type: String,
      default: ''
    },
    imId: {
      // imid
      type: String,
      default: ''
    }
  },
  data() {
    return {
      audioUrl: '',
      currentMessageList: [],
      canplay: false,
      playCb: null,
      playing: false,
      catchTime: 0,
      catchScrollTop: 0
    }
  },
  mounted() {
    this.initList()
  },
  beforeUnmount() {
    this.stopAudio() // 离开im关闭语音播放
  },
  methods: {
    isShowImTime(i) {
      if (i === 0) {
        return true
      }
      const t1 = this.currentMessageList[i - 1].time
      const t2 = this.currentMessageList[i].time
      if (t2 - t1 > 5 * 60) {
        return true
      }
    },
    async initList() {
      try {
        let messageList = await getMessageListRecord({
          // hospitalID: baseOrgan.getbaseInfo().hospitalID,
          hospitalID: this.hospitalID,
          visitID: this.visitID
        })
        messageList = formatImMessage(messageList, this.visitID, this.imId)
        let pre = 0
        // 1 系统消息只展示时间，不显示内容
        // 2 撤回消息 展示xxx撤回了一条消息
        // 3 其它消息正常展示
        // 4 自定义消息type=== 1000 ,设置用户输入状态不展示
        this.currentMessageList = messageList.filter(item => {
          // const showTime = caculateTimeago(item.time * 1000)
          if (item.payload && item.payload.description === 'setStatus') {
            // 过滤掉设置用户状态的消息
            return false
          }
          if (item.time - pre > 60 * 5) {
            // 时间间隔5分钟
            item.showTime = true
            pre = item.time
          }
          return true
        })
      } catch (e) {
        console.log(e)
      }
    },
    onPlay({ message, cb }) {
      this.playCb = cb
      this.handleAudio(message.payload, cb)
    },
    //控制播放还是暂停音频文件
    handleAudio(item, cb) {
      if (item.url === this.audioUrl && this.audioUrl) {
        if (this.playing) {
          this.$refs.audioRef.pause()
          cb && cb.end()
          this.playing = false
        } else {
          this.$refs.audioRef.play()
          cb && cb.start()
          this.playing = true
        }
        return
      }
      this.playAudio(item)
      cb && cb.start()
      this.playing = true
    },
    onCanplay() {
      this.canplay = true
      this.$refs.audioRef.play()
    },
    //播放音频
    playAudio(item) {
      this.audioUrl = item.url
      // item.url = 'https://www.w3school.com.cn/i/audio/song.mp3'
      // this.audioUrl = 'https://www.w3school.com.cn/i/audio/song.mp3'
    },
    stopAudio(e) {
      this.playCb && this.playCb.end()
      this.audioUrl = ''
      this.playing = false
    },
    onError(e) {
      if (this.audioUrl && this.playCb) {
        this.stopAudio()
        this.playCb && this.playCb.end()
      }
    },
    isCustomTxt(payload) {
      // 是否是自定义消息-文本
      if (!payload || !payload.data) {
        return false
      }
      let data = payload.data
      try {
        data = JSON.parse(data) || {}
        if (['98', '99', '100'].includes(String(data.type))) {
          return true
        }
      } catch (e) {
        console.log(e)
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.message-scroll-wrap {
  position: relative;
  height: 100%;

  .no-message {
    text-align: center;
    font-size: 0.512rem;
    line-height: 0.853333rem;
    color: #6e7981;
    height: 0.853333rem;
  }
}
</style>
